import AssessmentIcon from '@material-ui/icons/Assessment'
import AssetTypeCreate from './AssetTypeCreate'
import AssetTypeEdit from './AssetTypeEdit'
import AssetList from './AssetTypeList'

const assetTypes = (permissions: string[]) => ({
  create: permissions.includes('create:assets') ? AssetTypeCreate : undefined,
  edit: permissions.includes('update:assets') ? AssetTypeEdit : undefined,
  icon: AssessmentIcon,
  list: permissions.includes('read:assets') ? AssetList : undefined,
  name: 'asset-types',
})

export default assetTypes
